import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
import TaskService from '../../services/task';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  tasks: [],
  taskList: []
};

const slice = createSlice({
  name: 'task',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET MANAGE tasks
    getTaskListSuccess(state, action) {
      state.isLoading = false;
      state.taskList = action.payload.listData || [];
      state.totalCount = action.payload.totalCount || 0;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow, deletetask } = slice.actions;

// ----------------------------------------------------------------------

export function getTaskList(query) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await TaskService.getList(query);
      dispatch(slice.actions.getTaskListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
